import { render, staticRenderFns } from "./nibrs_review_form.vue?vue&type=template&id=cbebff4e&scoped=true&"
import script from "./nibrs_review_form.vue?vue&type=script&lang=js&"
export * from "./nibrs_review_form.vue?vue&type=script&lang=js&"
import style0 from "./nibrs_review_form.vue?vue&type=style&index=0&id=cbebff4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbebff4e",
  null
  
)

export default component.exports